module.exports = __webpack_public_path__ + "img/safe.958fffaf.svg";